import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5261ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "s-date-picker" }
const _hoisted_2 = { class: "s-date-picker__controls" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s-date-picker__controls_divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SIcon = _resolveComponent("SIcon")!
  const _component_STextInput = _resolveComponent("STextInput")!
  const _component_STextElement = _resolveComponent("STextElement")!
  const _component_vDatePicker = _resolveComponent("vDatePicker")!
  const _component_SButton = _resolveComponent("SButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_STextInput, {
      id: _ctx.id,
      color: _ctx.color,
      "model-value": _ctx.stringValue,
      readonly: true,
      onClick: _ctx.handleToggleDropdown
    }, {
      before: _withCtx(() => [
        _createVNode(_component_SIcon, { name: "calendar" })
      ]),
      _: 1
    }, 8, ["id", "color", "model-value", "onClick"]),
    (_ctx.showTimeZone)
      ? (_openBlock(), _createBlock(_component_STextElement, {
          key: 0,
          class: "s-date-picker__offset",
          color: "stroke"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.baseTimeZone.name) + " " + _toDisplayString(_ctx.timeZoneOffset), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.state.isMenuOpened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.dropdownClasses)
        }, [
          _createVNode(_component_vDatePicker, {
            ref: "datePickerRef",
            modelValue: _ctx.state.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.value) = $event)),
            attributes: _ctx.attributes,
            is24hr: _ctx.is24hr,
            locale: _ctx.localeSetting,
            "max-date": _ctx.maxDate,
            "min-date": _ctx.minDate,
            mode: _ctx.mode,
            class: "s-date-picker__calendar",
            "trim-weeks": "",
            onDayclick: _ctx.handleDayClick
          }, null, 8, ["modelValue", "attributes", "is24hr", "locale", "max-date", "min-date", "mode", "onDayclick"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SButton, {
              text: _ctx.buttons.ok,
              class: "s-date-picker__button date-picker__button_submit",
              size: "s",
              variant: "transparent",
              onClick: _ctx.handleSubmitClick
            }, null, 8, ["text", "onClick"]),
            _hoisted_3,
            _createVNode(_component_SButton, {
              text: _ctx.buttons.cancel,
              class: "s-date-picker__button date-picker__button_cancel",
              color: "danger",
              size: "s",
              variant: "transparent",
              onClick: _ctx.handleCancelClick
            }, null, 8, ["text", "onClick"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.handleClickOutside]
  ])
}